import React, { useEffect, useState } from 'react'
import { useNotification } from '../../../hooks/notification.hook'
import { emmiter } from '../../../helpers/Emmiter'
import Modal from '../../modal/modal'
import Button from '../../ui/button/button'
import { CustomWorkUser } from './CustomWorkUser'
import stageStore from '../../../store/stage'
import usersStore from '../../../store/users'
import Input from '../../ui/input/input'
import DropdownHOC from '../../dropdownHOC/dropdownHOC'
import usePosition from '../../../hooks/position.hook'
import Loader from '../../loader/loader'


export const CustomWorkModal = () => {
  const notification = useNotification()
  const [modal, setModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState({isOpen: false})
  const [user, setUser] = useState(null)
  const { username, id: userId } = user || {}
  const [formData, setFormData] = useState({})
  const [isFormValid, setIsFormValid] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [renderedUsers, setRenderedUsers] = useState([])


  const { createCustomWork, deleteCustomWork, getCustomWorksForPosition } = usePosition()

  const getData = async () => {
    if(!modal.id) return;

    setIsLoading(true)
    const res = await getCustomWorksForPosition(modal.id)
    setRenderedUsers(res.result || [])
    setIsLoading(false)
    return res
  }

  useEffect(() => {
    getData()
  }, [modal.id])

  useEffect(() => {
    const workTitle = formData.title
    const hours = formData.hours
    const minutes = formData.minutes
    const user = formData.user
    let isFormValid = workTitle && user && (hours || minutes)
    setIsFormValid(isFormValid)
  }, [formData, user])

  useEffect(() => {
    emmiter.on('customWorkModal', data => {
      setModal(data)
    })
    return () => {
      emmiter.off('customWorkModal')
    }
  }, [])

  const stageRoles = stageStore.currentStage.m_roles || []
  const stageRoleIds = stageRoles.map(role => role.id)
  const candidates = usersStore.users
    .filter(x => x.m_roles.some(y => stageRoleIds.includes(y.id)))
    .map(x => ({ title: x.username, onEvent: () => onSetUser(x) }))
    .sort((a, b) => a.title.localeCompare(b.title, 'ru'))

  const onSetUser = user => {
    setUser(user)
    setFormData({ ...formData, user })
  }

  const onChangeFormData = (value, key) => {
    setFormData({ ...formData, [key]: value })
  }


  const onCreateCustomWork = async () => {
    if(!isFormValid) return;
    try {
      const data = {
        workTitle: formData.title,
        user: userId,
        position: modal.id,
        positionTitle: modal.title,
        workMinutes: (Number(formData.hours || 0) * 60) + Number(formData.minutes || 0),
        readableTime: `${formData.hours || 0} ч. ${formData.minutes && !['0', '00'].includes(formData.minutes)
          ? `${Number(formData.minutes)} мин.`
          : ''}`.trim()
      }
      setIsLoading(true)
      await createCustomWork(data)
      const res = await getData()

      if(res.status === 200) {
        setFormData({})
        setUser(null)
        notification('Запись создана', 'success')
      }

    } catch(e) {
      notification('Что то пошло не так', 'err')
    } finally {
      setIsLoading(false)
    }
  }


  const onCloseModal = () => {
    setModal(false)
    setFormData({})
    setUser(null)
    modal.getData(true)
  }

  const onDeleteApprove = async () => {
    try {
      setIsLoading(true)
      const res = await deleteCustomWork(deleteModal.workId)
      if(res.status === 200) {
        setFormData({})
        setUser(null)
        setDeleteModal({isOpen: false})
        notification('Запись удалена', 'success')
        await getData()

      }
    } catch(e) {
      notification('Что то пошло не так', 'err')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal isOpen={!!modal} closeModal={onCloseModal}>
      <div className='w-[90vw] max-w-[76rem] min-h-[10rem] pt-[7rem]'>
        <span className='block text-center text-Regular(48_52) text-Content/Dark mb-[2rem]'>Дополнительные работы</span>
        <div className='text-Regular(14_16) text-center text-Content/Middle'>
          Добавьте описание работы с позицией и затраченное время
        </div>
        <div className='p-[3rem]'>
          <div className='py-[5rem] px-[4rem] bg-Dominant/Dop min-h-[15rem] relative'>
                <>
                  <span className='text-Regular(16_18)'>{modal.title}</span>
                  <div className='flex flex-col mt-10'>
                    <div className='text-Regular(16_18) font-medium'>Исполнители:</div>
                    <div className='flex flex-col gap-[8px] mt-[8px]'>
                      {renderedUsers.map((u) => (
                        <CustomWorkUser  key={u.title} userData={u} setDeleteModal={setDeleteModal} getData={getData} positionId={modal.id}/>
                      ))}
                    </div>
                  </div>

                  <div className={`mt-[4rem]`}>
                    <div className={``}>
                      <Input
                        type='text'
                        onInput={({ target: { value } }) => onChangeFormData(value, 'title')}
                        placeholder='Введите название работы'
                        initial={formData.title || ''}></Input>
                    </div>
                    <div className={`grid grid-cols-[20%_20%_1fr]`}>
                      <Input
                        type='number'
                        onInput={({ target: { value } }) => onChangeFormData(value, 'hours')}
                        placeholder='Часы'
                        maxValue={24}
                        maxLength={2}
                        initial={formData.hours || ''}></Input>
                      <Input
                        type='number'
                        onInput={({ target: { value } }) => onChangeFormData(value, 'minutes')}
                        placeholder='Минуты'
                        maxValue={59}
                        maxLength={2}
                        initial={formData.minutes || ''}></Input>
                      <DropdownHOC
                        items={candidates}
                        title={username || 'Выберите исполнителя'}
                        className='flex items-center h-[100%] bg-white'></DropdownHOC>
                    </div>
                  </div>

                  <div className='flex justify-center mt-[3.8rem]'>
                    <Button disabled={!isFormValid} name='Сохранить' onPress={onCreateCustomWork}></Button>
                  </div>
                </>
            {isLoading && <div className={`absolute inset-0 bg-[rgba(114,_112,_112,_0.5)] z-2`}><Loader /></div>}
          </div>
        </div>
      </div>
      <Modal closeModal={() => setDeleteModal({isOpen: false})}
             isOpen={deleteModal.isOpen}>
        <div className="w-[62rem] min-h-[10rem]">
          <div className="py-[5rem] px-[7rem]">
            <div className="flex flex-col gap-[2rem]">
              <span className="text-Regular(24_30) text-center">Внимание!</span>
              <span className="text-Regular(18_24) text-center">
                Вы действительно хотите удалить выбранную работу?
              </span>
              <div className="flex justify-center gap-[5rem]">
                <div onClick={onDeleteApprove}
                     className="hover:bg-Accent/Light_Green hover:cursor-pointer duration-300 ease-in-out min-w-[19rem] py-[1.1rem] group px-[1.8rem]  font-medium rounded-[8px] bg-Accent/Green text-white text-Regular(16_20)">
                  <span
                    className="flex justify-center  items-center gap-[0.8rem]">
                    <span>Да, удалить</span>
                    <i className="icon-fcheck-circle text-Regular(18_24)"></i>
                  </span>
                </div>
                <div
                  onClick={() => setDeleteModal({isOpen: false})}
                  className="hover:bg-Accent/Red_Middle hover:cursor-pointer duration-300 ease-in-out min-w-[19rem] py-[1.1rem] group px-[1.8rem]  font-medium rounded-[8px] bg-Accent/Red text-white text-Regular(16_20)">
                  <span
                    className="flex justify-center  items-center gap-[0.8rem]">
                    <span>Отмена</span>
                    <i className="icon-times-circle text-Regular(18_24)"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Modal>
  )
}
